import {
    Box,
    Button,
    Container,
    FormControl,
    FormControlLabel,
    MenuItem,
    Paper,
    Radio,
    RadioGroup,
    Select,
    Tab,
    Table,
    TableBody,
    TableCell,
    TableContainer,
    TableHead,
    TableRow,
    Tabs,
    TextField,
    Tooltip,
    Typography,
    useMediaQuery,
} from "@material-ui/core";
import { makeStyles } from "@material-ui/core/styles";
import InfoIcon from "@material-ui/icons/Info";
import Autocomplete from "@mui/material/Autocomplete/Autocomplete";
import Config from "Config";
import cloneDeep from "lodash/cloneDeep";
import PropTypes from "prop-types";
import React, { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { useDispatch, useSelector } from "react-redux";
import { send } from "../../SendRequest";
import {
    getFormTitleParam,
    getIsReleasedForm,
    intToformId,
    isNotEmpty,
    isObjectEmpty,
    isObjectNotEmpty,
} from "../../Utils";
import CustomTextField from "../../inputComponent/CustomTextField/CustomTextField";
import { getSelectFormList } from "../../redux/action";
import {
    getFormTitleParamList,
    getProfile,
    getSelectedUserOrg,
} from "../../redux/selector";
import AlertDialog from "../AlertDialog/AlertDialog";
import FormBox from "../FormBox/FormBox";
import Header from "../Header/Header";
import PortalNavbar from "../PortalNavbar/PortalNavbar";

function TabPanel(props) {
    const { children, value, index, ...other } = props;

    return (
        <div
            role="tabpanel"
            hidden={value !== index}
            id={`simple-tabpanel-${index}`}
            label={`simple-tab-${index}`}
            {...other}
        >
            {value === index && <Box>{children}</Box>}
        </div>
    );
}

TabPanel.propTypes = {
    children: PropTypes.node,
    index: PropTypes.any.isRequired,
    value: PropTypes.any.isRequired,
};

function a11yProps(index) {
    return {
        id: `simple-tab-${index}`,
        "aria-controls": `simple-tabpanel-${index}`,
    };
}

const useStyles = makeStyles({
    root: {
        width: "85%",
        margin: "6px 100px 0px 50px",
        flex: 1,
    },
    rootMobile: {
        margin: "6px 0px 0px 0px",
        flex: 1,
    },
    container: {
        maxHeight: 250,
    },
    tableRow: {
        height: 15,
    },
    reminderBox: {
        alignItems: "center",
        display: "flex",
        justifyContent: "space-between",
        padding: "0px 100px 0px 20px",
    },
    reminderBoxMobile: {
        alignItems: "center",
        display: "flex",
        justifyContent: "space-between",
        padding: "0px 20px 0px 20px",
    },
    tableCell: {
        textAlign: "center",
        fontWeight: "bold",
    },
});

//Part1: choose user-responsible forms:get default shown-> smallest id
var userFormsNum = [];

function getSmallestFormId(array) {
    array.map((i) => {
        if (userFormsNum.length < array.length) {
            userFormsNum.push(i.replace(/^Form0+/, ""));
        }
        Number(userFormsNum[i]);
    });
    return Math.min(...userFormsNum);
}

function DelegationPage(props) {
    const { t, i18n } = useTranslation();
    const classes = useStyles();
    const matches = useMediaQuery("(min-width:600px)");
    const dispatch = useDispatch();

    const [newPartOne, setNewPartOne] = useState({});
    const [newPartTwo, setNewPartTwo] = useState({});
    const [refresh, setRefresh] = useState({});
    const [isSavedOpen, setIsSavedOpen] = useState(false);
    const [errorCode, setErrorCode] = useState("");
    const [formList, setFormList] = useState([]);
    const [selectedForm, setSelectedForm] = useState(0);
    const [newFormSelected, setNewFormSelected] = useState(false);
    const selectedUserOrg = useSelector(getSelectedUserOrg());
    const profile = useSelector(getProfile());

    const formTitleParam = useSelector(getFormTitleParamList());

    // const cloTwoForms = [21, 22, 31, 32, 33, 34, 82];
    // const [workflowNum, setWorkflowNum] = useState(1);
    // const workflowNumList = new Array(99).fill([1]);
    // cloTwoForms.forEach((i) => (workflowNumList[i - 1] = [1, 2]));
    // console.log("#:", workflowNum);
    const statusPerRole = [
        "selectedApplicant",
        "selectedApprover",
        "selectedApprover",
        "selectedSecondApprover",
        "selectedSecondApprover",
        "selectedThirdApprover",
        "selectedThirdApprover",
        "selectedFourthApprover",
        "selectedFourthApprover",
    ];

    function checkTokenCookieExists() {
        if (
            document.cookie
                .split(";")
                .some((item) => item.trim().startsWith("token="))
        ) {
            return true;
        } else {
            return false;
        }
    }

    useEffect(() => {
        if (isNotEmpty(selectedUserOrg)) {
            const scrn = selectedUserOrg.scrn ? selectedUserOrg.scrn : "";
            if (
                scrn != "" ||
                (["SLA", "SH"].indexOf(profile.role) != -1 &&
                    selectedUserOrg.scrn === null)
            ) {
                const option = {
                    url: `${Config.CONTENT_PATH}/form/getFormDropdown/${scrn}`,
                };
                dispatch(send("GET_DELEGATION_FORM_DROPDOWN", option))
                    .then((response) => response.json())
                    .then((result) => {
                        if (result?.code === "0") {
                            result = result?.data?.filter((id) =>
                                getIsReleasedForm(intToformId(id))
                            );
                            setFormList(result);
                            setSelectedForm(result?.[0]);
                        } else {
                            setErrorCode(result.code);
                        }
                    })
                    .catch((error) => console.log("fetch error", error));
            }
        }
        /*return () => {
            if (checkTokenCookieExists()) {
                console.log("B");
                dispatch(getSelectFormList(selectedUserOrg));
            }
        };*/
    }, [selectedUserOrg]);

    useEffect(() => {
        setNewFormSelected(!newFormSelected);
        const userData = { scrn: selectedUserOrg.scrn };
        const option = {
            url: `${Config.CONTENT_PATH}/delegation/form/${selectedForm}`,
            method: "POST",
            body: JSON.stringify(userData),
        };

        if (selectedForm != 0 && isObjectNotEmpty(selectedUserOrg)) {
            dispatch(send("GET_FORM_DELEGATION", option))
                .then((response) => response.json())
                .then((data) => {
                    setData(data);
                    setNewPartOne(cloneDeep(data));
                    if (
                        data["selectedFourthApprover"].length > 0 &&
                        data["selectedThirdApprover"].length == 0 &&
                        data["selectedSecondApprover"].length == 0 &&
                        data["selectedApplicant"].length == 0 &&
                        data["selectedApprover"].length == 0
                    ) {
                        setTabOne(4);
                    } else if (
                        data["selectedThirdApprover"].length > 0 &&
                        data["selectedSecondApprover"].length == 0 &&
                        data["selectedApplicant"].length == 0 &&
                        data["selectedApprover"].length == 0
                    ) {
                        setTabOne(3);
                    } else if (
                        data["selectedSecondApprover"].length > 0 &&
                        data["selectedApplicant"].length == 0 &&
                        data["selectedApprover"].length == 0
                    ) {
                        setTabOne(2);
                    } else if (
                        data["selectedApprover"].length > 0 &&
                        data["selectedApplicant"].length == 0
                    ) {
                        setTabOne(1);
                    } else {
                        setTabOne(0);
                    }
                })
                .catch((error) => {
                    console.log("fetch error: ", error);
                    setData({});
                });
        }
    }, [selectedForm, refresh, selectedUserOrg]);

    // function handleSubmit(e) {
    //     e.preventDefault();
    //     data[`formId`] = selectedForm;
    //     data[`scrn`] = selectedUserOrg.scrn;
    //     // alert("InitialPart1:" + JSON.stringify(data));

    //     // alert("specificList(Temp)=====" + JSON.stringify(newPartTwo)); //Update One-time part 2
    //     if (!isObjectEmpty(newPartTwo)) {
    //         newPartTwo[`scrn`] = selectedUserOrg.scrn;
    //         const newStateTwo = Object.assign({}, newPartTwo);
    //         setNewPartTwo(newStateTwo);
    //         const option = {
    //             url: `${Config.CONTENT_PATH}/workflow/delegation`,
    //             method: "POST",
    //             body: JSON.stringify(newPartTwo),
    //         };
    //         dispatch(send("SUBMIT_SPECIFIC_DELEGATION", option))
    //             .then((res) => res.json())
    //             .then((result) => console.log(result)),
    //             (error) => {
    //                 console.log("error:" + error.message);
    //             };
    //     }
    //     if (isTemp === "false") {
    //         //Perm
    //         const permData = Object.assign({}, newPartTwo);
    //         permData[`formId`] = selectedForm;
    //         permData[`scrn`] = selectedUserOrg.scrn;

    //         setData(permData);
    //         // alert("2CopiedToDel=====" + JSON.stringify(permData));
    //         const option = {
    //             url: `${Config.CONTENT_PATH}/delegation/form/${workflowNum}`,
    //             method: "POST",
    //             body: JSON.stringify(permData),
    //         };
    //         dispatch(send("SUBMIT_FORM_DELEGATION", option))
    //             .then((res) => res.json())
    //             .then((result) => console.log(result)),
    //             (error) => {
    //                 console.log("error:" + error.message);
    //             };
    //     } else {
    //         newPartOne[`scrn`] = selectedUserOrg.scrn;
    //         const newState = Object.assign({}, newPartOne);
    //         setNewPartOne(newState);

    //         const option = {
    //             url: `${Config.CONTENT_PATH}/delegation/form/${workflowNum}`,
    //             method: "POST",
    //             body: JSON.stringify(newPartOne),
    //         };
    //         dispatch(send("SUBMIT_FORM_DELEGATION", option))
    //             .then((res) => res.json())
    //             .then((result) => console.log(result)),
    //             (error) => {
    //                 console.log("error:" + error.message);
    //             };
    //     }
    //     setRefresh({});
    // }

    function handlePartOneSubmit() {
        newPartOne[`scrn`] = selectedUserOrg.scrn;
        const option = {
            url: `${Config.CONTENT_PATH}/delegation/form`,
            method: "POST",
            body: JSON.stringify(newPartOne),
        };
        dispatch(send("SUBMIT_FORM_DELEGATION", option))
            .then((res) => res.json())
            .then((result) => {
                console.log(result);
                setRefresh({});
                //fetch for applicant form list when save success
                dispatch(getSelectFormList(selectedUserOrg));
            }),
            (error) => {
                console.log("error:" + error.message);
            };
        setRefresh({});
        setIsSavedOpen(true);
    }

    function handlePartTwoSubmit() {
        if (!isObjectEmpty(newPartTwo)) {
            newPartTwo[`scrn`] = selectedUserOrg.scrn;
            const option = {
                url: `${Config.CONTENT_PATH}/workflow/delegation`,
                method: "POST",
                body: JSON.stringify(newPartTwo),
            };
            dispatch(send("SUBMIT_SPECIFIC_DELEGATION", option))
                .then((res) => res.json())
                .then((result) => {
                    setRefresh({});
                    console.log(result);
                }),
                (error) => {
                    console.log("error:" + error.message);
                };
        }
        if (isTemp === "false") {
            //Perm
            const permData = Object.assign({}, newPartTwo);
            permData[`formId`] = selectedForm;
            permData[`scrn`] = selectedUserOrg.scrn;
            setData(permData);
            // alert("2CopiedToDel=====" + JSON.stringify(permData));
            const option = {
                url: `${Config.CONTENT_PATH}/delegation/form`,
                method: "POST",
                body: JSON.stringify(permData),
            };
            dispatch(send("SUBMIT_FORM_DELEGATION", option))
                .then((res) => res.json())
                .then((result) => {
                    setRefresh({});
                    //console.log(result)
                }),
                (error) => {
                    console.log("error:" + error.message);
                };
        }
        setRefresh({});
        setIsSavedOpen(true);
    }

    useEffect(() => {
        getSpecificFormDetail();
    }, [refresh]);

    const [data, setData] = useState({});
    const [fullList, setFullList] = useState({});

    const [tabOne, setTabOne] = useState(0);
    const handleTabOneChange = (event, newValue) => {
        setTabOne(newValue);
    };

    const [tabTwo, setTabTwo] = useState(0);
    const handleTabTwoChange = (event, newValue) => {
        setTabTwo(newValue);
    };

    // Part1
    //console.log("SelectedForm:" + selectedForm);

    function fetchFullList() {
        if (selectedForm != 0 && isObjectNotEmpty(selectedUserOrg)) {
            const option = {
                url: `${Config.CONTENT_PATH}/delegation/getRelatedUser/${selectedForm}`,
                method: "POST",
                body: JSON.stringify({ scrn: selectedUserOrg.scrn }),
            };
            dispatch(send("GET_RELATED_DELEGATION_USER", option))
                .then((response) => response.json())
                .then((result) => {
                    setFullList(result);
                })
                .catch((error) => {
                    console.log("fetch error: ", error);
                });
        }
    }

    useEffect(() => {
        fetchFullList();
        setRefNum("");
        setSpecificList({});
        // setWorkflowNum(1);
    }, [selectedForm, refresh, selectedUserOrg]);

    // Part2
    const [refNum, setRefNum] = useState("");
    const [specificList, setSpecificList] = useState({});
    const [isTemp, setIsTemp] = useState("true");
    const [isInitialSpecific, setIsInitialSpecific] = useState(true);
    const [specificFlowNum, setSpecificFlowNum] = useState(null);

    function getSpecificFormDetail() {
        if (refNum != "") {
            const userData = { scrn: selectedUserOrg.scrn };
            const option = {
                url: `${Config.CONTENT_PATH}/workflow/delegation/form/${selectedForm}/${refNum}`,
                method: "POST",
                body: JSON.stringify(userData),
            };
            dispatch(send("GET_SPECIFIC_DELEGATION", option))
                .then((response) => response.json())
                .then((data) => {
                    setSpecificFlowNum(data.workflowNum);
                    setSpecificList(data);
                    setNewPartTwo(cloneDeep(data));
                    if (
                        data["selectedFourthApprover"].length > 0 &&
                        data["selectedThirdApprover"].length == 0 &&
                        data["selectedSecondApprover"].length == 0 &&
                        data["selectedApplicant"].length == 0 &&
                        data["selectedApprover"].length == 0
                    ) {
                        setTabTwo(4);
                    } else if (
                        data["selectedThirdApprover"].length > 0 &&
                        data["selectedSecondApprover"].length == 0 &&
                        data["selectedApplicant"].length == 0 &&
                        data["selectedApprover"].length == 0
                    ) {
                        setTabTwo(3);
                    } else if (
                        data["selectedSecondApprover"].length > 0 &&
                        data["selectedApplicant"].length == 0 &&
                        data["selectedApprover"].length == 0
                    ) {
                        setTabTwo(2);
                    } else if (
                        data["selectedApprover"].length > 0 &&
                        data["selectedApplicant"].length == 0
                    ) {
                        setTabTwo(1);
                    } else {
                        setTabTwo(0);
                    }
                })
                .catch((error) => {
                    console.log("fetch error: ", error);
                    setSpecificList({});
                    setIsInitialSpecific(false);
                });
        }
    }

    function selectedTable(roleList) {
        let options = [];
        if (!isObjectEmpty(fullList[roleList]) && !isObjectEmpty(data)) {
            fullList[roleList].map((item) => {
                options.push(item);
                // if (
                //     !data[roleList].some(
                //         (x) => x.interfaceUsername === item.interfaceUsername
                //     )
                // ) {
                //     if (item.interfaceUsername)
                //         item.label = item.interfaceUsername;
                //     options.push(item);
                // }
            });
        }

        function changeRole(newItem, oldValue) {
            const index = data[roleList].indexOf(oldValue);

            if (newItem != null) {
                newPartOne[roleList].splice(index, 1, newItem);
                const newState = Object.assign({}, newPartOne);
                setNewPartOne(newState);
            }
        }

        return (
            <TableContainer component={Paper}>
                <Table stickyHeader size="small" aria-label="each layer list">
                    <TableHead style={{ whiteSpace: "nowrap" }}>
                        <TableRow>
                            <TableCell className={classes.tableCell}>
                                {t(`common.delegation.name`)}
                            </TableCell>
                            <TableCell className={classes.tableCell}>
                                {t(`common.delegation.email`)}
                            </TableCell>
                            <TableCell className={classes.tableCell}>
                                {t(`common.delegation.post`)}
                            </TableCell>
                            <TableCell
                                className={classes.tableCell}
                                width="40%"
                            >
                                {t(`common.delegation.replaceTo`)}
                            </TableCell>
                        </TableRow>
                    </TableHead>
                    <TableBody>
                        {!isObjectEmpty(data) ? (
                            data?.[roleList]?.map((item) => {
                                return (
                                    <TableRow key={item.id}>
                                        <TableCell align="center">
                                            {item.name}
                                            {t(`common.bracketLeft`)}
                                            {item.interfaceUsername}
                                            {t(`common.bracketRight`)}
                                        </TableCell>
                                        <TableCell align="center">
                                            <a
                                                href={`mailto:${item.email}`}
                                                style={{
                                                    color: "black",
                                                }}
                                            >
                                                {item.email}
                                            </a>
                                        </TableCell>
                                        <TableCell align="center">
                                            {item.post}
                                        </TableCell>
                                        <TableCell>
                                            {isObjectNotEmpty(fullList) && (
                                                <Autocomplete
                                                    key={newFormSelected}
                                                    id="replaceToSelect"
                                                    options={options}
                                                    getOptionLabel={(option) =>
                                                        `${option.name}${t(
                                                            `common.bracketLeft`
                                                        )}${
                                                            option.interfaceUsername
                                                        }${t(
                                                            `common.bracketRight`
                                                        )}<${option.email}>`
                                                    }
                                                    blurOnSelect
                                                    sx={{
                                                        width: "100%",
                                                        minWidth: 200,
                                                    }}
                                                    slotProps={{
                                                        popper: {
                                                            modifiers: [
                                                                {
                                                                    name: "flip",
                                                                    enabled: true,
                                                                },
                                                                {
                                                                    name: "preventOverflow",
                                                                    enabled: true,
                                                                    options: {
                                                                        altAxis: true,
                                                                        boundary:
                                                                            "clippingParents",
                                                                    },
                                                                },
                                                            ],
                                                            sx: {
                                                                minWidth:
                                                                    "100%",
                                                                "& .MuiAutocomplete-listbox":
                                                                    {
                                                                        "& .MuiAutocomplete-option":
                                                                            {
                                                                                whiteSpace:
                                                                                    "normal",
                                                                                lineHeight:
                                                                                    "1.5",
                                                                            },
                                                                    },
                                                            },
                                                        },
                                                    }}
                                                    renderInput={(params) => (
                                                        <>
                                                            <TextField
                                                                {...params}
                                                                variant="standard"
                                                                label="replaceTo"
                                                                className="hiddenLabel"
                                                                // id={item.id}
                                                                // inputProps={{
                                                                //     "aria-label": `${item.id}`,
                                                                // }}
                                                            />
                                                        </>
                                                    )}
                                                    onChange={(e, newValue) => {
                                                        changeRole(
                                                            newValue,
                                                            item
                                                        );
                                                    }}
                                                />
                                            )}
                                        </TableCell>
                                    </TableRow>
                                );
                            })
                        ) : (
                            <TableRow>
                                <TableCell
                                    colSpan={4}
                                    style={{
                                        textAlign: "center",
                                    }}
                                >
                                    No result is found.
                                </TableCell>
                            </TableRow>
                        )}
                    </TableBody>
                </Table>
            </TableContainer>
        );
    }

    function specificTable(roleList) {
        let options = [];
        if (
            !isObjectEmpty(fullList[roleList]) &&
            !isObjectEmpty(specificList)
        ) {
            fullList[roleList].map((item) => {
                if (
                    !specificList[roleList].some(
                        (x) => x.interfaceUsername === item.interfaceUsername
                    )
                ) {
                    options.push(item);
                }
            });
        }

        function changeRoleSpecific(newItem, oldValue) {
            const index = specificList[roleList].indexOf(oldValue);

            if (newItem != null) {
                newPartTwo[roleList].splice(index, 1, newItem);
                const newState = Object.assign({}, newPartTwo);
                setNewPartTwo(newState);
            }
        }

        return (
            <TableContainer component={Paper}>
                <Table stickyHeader size="small" aria-label="each layer list">
                    <TableHead style={{ whiteSpace: "nowrap" }}>
                        <TableRow>
                            <TableCell className={classes.tableCell}>
                                {t(`common.delegation.name`)}
                            </TableCell>
                            <TableCell className={classes.tableCell}>
                                {t(`common.delegation.email`)}
                            </TableCell>
                            <TableCell className={classes.tableCell}>
                                {t(`common.delegation.post`)}
                            </TableCell>
                            <TableCell
                                className={classes.tableCell}
                                width="40%"
                            >
                                {t(`common.delegation.replaceTo`)}
                            </TableCell>
                        </TableRow>
                    </TableHead>
                    <TableBody>
                        {!isObjectEmpty(specificList) &&
                            specificList[roleList].map((item) => (
                                <TableRow key={item.email}>
                                    <TableCell align="center">
                                        {item.name}
                                        {t(`common.bracketLeft`)}
                                        {item.interfaceUsername}
                                        {t(`common.bracketRight`)}
                                    </TableCell>
                                    <TableCell align="center">
                                        <a
                                            href={`mailto:${item.email}`}
                                            style={{
                                                color: "black",
                                            }}
                                        >
                                            {item.email}
                                        </a>
                                    </TableCell>
                                    <TableCell align="center">
                                        {item.post}
                                    </TableCell>
                                    <TableCell>
                                        {isObjectNotEmpty(fullList) && (
                                            <Autocomplete
                                                disabled={
                                                    statusPerRole.indexOf(
                                                        roleList
                                                    ) < specificList.status
                                                }
                                                key={newFormSelected}
                                                options={options}
                                                getOptionLabel={(option) =>
                                                    `${option.name}${t(
                                                        `common.bracketLeft`
                                                    )}${
                                                        option.interfaceUsername
                                                    }${t(
                                                        `common.bracketRight`
                                                    )}<${option.email}>`
                                                }
                                                blurOnSelect
                                                renderInput={(params) => (
                                                    <TextField
                                                        {...params}
                                                        variant="standard"
                                                    />
                                                )}
                                                onChange={(e, newValue) => {
                                                    changeRoleSpecific(
                                                        newValue,
                                                        item
                                                    );
                                                }}
                                            />
                                        )}
                                    </TableCell>
                                </TableRow>
                            ))}
                    </TableBody>
                </Table>
            </TableContainer>
        );
    }

    function tempRadio() {
        return (
            <Box display="flex">
                <Typography
                    style={{ alignSelf: "center" }}
                    variant="h6"
                    component="h1"
                >
                    {t("common.delegation.change")}
                </Typography>
                <Tooltip
                    title={
                        <Typography
                            style={{
                                fontSize: "12px",
                            }}
                        >
                            {t("common.delegation.changeContent")}
                        </Typography>
                    }
                >
                    <InfoIcon
                        style={{ alignSelf: "center", marginLeft: "0.2rem" }}
                    />
                </Tooltip>

                <FormControl
                    component="fieldset"
                    style={{ marginLeft: "1rem" }}
                >
                    <RadioGroup
                        row
                        aria-label="type"
                        defaultValue={isTemp}
                        name="radio-buttons-group"
                        onChange={(e) => {
                            handleTempRadioChange(e);
                        }}
                    >
                        <FormControlLabel
                            value="true"
                            control={<Radio />}
                            label={t("common.delegation.oneTime")}
                        />
                        <FormControlLabel
                            value="false"
                            control={<Radio />}
                            label={t("common.delegation.permanent")}
                        />
                    </RadioGroup>
                </FormControl>
            </Box>
        );
    }

    function handleTempRadioChange(e) {
        setIsTemp(e.target.value);
    }

    function getFormIDwithZero(num) {
        return String(num).padStart(3, "0");
    }

    // const role = useSelector(getUserRole());
    // const layersNum = new Array(99).fill(3);
    // const layerTwoList = [4, 5, 6, 7, 15, 41, 42, 47, 51];
    // const layerFourList = [3, 13, 14, 28, 85, 87, 88, 89];
    // layerTwoList.forEach((i) => (layersNum[i - 1] = 2));
    // layerFourList.forEach((j) => (layersNum[j - 1] = 4));
    // if (role === "SH" || role === "SLA") {
    //     layersNum[11] = 4; //Form12
    // }

    // function getLayerPerForm() {
    //     return layersNum[selectedForm - 1];
    // }
    // const customLayers = [
    //     "selectedApplicant",
    //     "selectedApprover",
    //     "selectedSecondApprover",
    //     "selectedEdbReviewer",
    // ];
    // const customLayersLabel = [
    //     "Applicant",
    //     "Approver",
    //     "SecondApprover",
    //     "EdbReviewer",
    // ];

    // console.log("data:" + JSON.stringify(data));
    // console.log("length:"+data[])
    // console.log("new part one:" + JSON.stringify(newPartOne));
    // console.log("SpecificList:" + JSON.stringify(specificList));
    // console.log("new part two:" + JSON.stringify(newPartTwo));

    return (
        <Container maxWidth="md">
            <Header
                headerTitle={t("common.sideNavList.delegationPage")}
                className="header"
            ></Header>
            <Box className="container">
                <PortalNavbar aside className="drawer" />
                {isNotEmpty(errorCode) ? (
                    <Typography style={{ margin: "100px" }}>
                        {t(`errorMsg.getFormDropdown.${errorCode}`)}
                    </Typography>
                ) : (
                    formList.length > 0 &&
                    selectedForm != 0 && (
                        <main className="main">
                            <form>
                                <Box
                                    style={{
                                        marginLeft: "15px",
                                        marginRight: "15px",
                                    }}
                                >
                                    {/* onSubmit={handleSubmit} */}
                                    {/* Part0 */}
                                    <Box>
                                        <Typography
                                            variant="h6"
                                            component="h1"
                                            style={{ marginBottom: "0.5 rem" }}
                                        >
                                            {t(
                                                "common.delegation.instructionOne"
                                            )}
                                        </Typography>
                                        <Typography component="span">
                                            {t("common.portal.forForm")}&nbsp;
                                        </Typography>
                                        <FormControl id="formsId">
                                            <Select
                                                label="formsId"
                                                labelId="formsId"
                                                inputProps={{
                                                    "aria-labelledby":
                                                        "formsId",
                                                }}
                                                defaultValue={selectedForm}
                                                style={{ textAlign: "end" }}
                                                onChange={(e) =>
                                                    setSelectedForm(
                                                        e.target.value
                                                    )
                                                }
                                            >
                                                {formList.map((element) => (
                                                    <MenuItem
                                                        value={element}
                                                        key={element}
                                                    >
                                                        {element}
                                                    </MenuItem>
                                                ))}
                                            </Select>
                                        </FormControl>
                                        <Typography component="span">
                                            :
                                        </Typography>
                                        <Typography>
                                            {t(
                                                `form.Form${selectedForm
                                                    .toString()
                                                    .padStart(3, "0")}`,
                                                getFormTitleParam(
                                                    selectedForm,
                                                    formTitleParam,
                                                    i18n.language
                                                )
                                            )}
                                        </Typography>
                                    </Box>

                                    {/* Part1 */}
                                    <Box>
                                        <Typography variant="h6" component="h1">
                                            <br />
                                            1.{" "}
                                            {t(
                                                `common.delegation.formDelegation`
                                            )}
                                        </Typography>
                                        <Typography
                                            style={{ marginBottom: "0.5rem" }}
                                        >
                                            {t(
                                                "common.delegation.explanationOne"
                                            )}
                                        </Typography>
                                        <Typography
                                            style={{
                                                whiteSpace: "pre-line",
                                                marginBottom: "0.5rem",
                                            }}
                                        >
                                            {t(
                                                `common.delegation.instructionTwo`
                                            )
                                                .split("<br/>")
                                                .join("\n")}
                                        </Typography>
                                        {/* <Box>
                                    <Typography
                                        component="span"
                                        style={{ fontSize: "1.1rem" }}
                                    >
                                        {t("common.portal.workflowType")}
                                    </Typography>
                                    <Select
                                        key={refresh}
                                        label="workflowNum"
                                        value={workflowNum}
                                        style={{ textAlign: "end" }}
                                        onChange={(e) =>
                                            setWorkflowNum(e.target.value)
                                        }
                                    >
                                        {workflowNumList[selectedForm - 1].map(
                                            (element) => (
                                                <MenuItem
                                                    value={element}
                                                    key={element}
                                                >
                                                    {element === 2
                                                        ? "CLO 2"
                                                        : "CLO 1"}
                                                </MenuItem>
                                            )
                                        )}
                                    </Select>
                                </Box> */}
                                        <Paper square>
                                            <Tabs
                                                value={tabOne}
                                                onChange={handleTabOneChange}
                                                aria-label="each level workflow assignee"
                                                centered
                                            >
                                                {!isObjectEmpty(data) &&
                                                    data["selectedApplicant"]
                                                        .length != 0 && (
                                                        <Tab
                                                            label={t(
                                                                `common.portal.applicant`
                                                            )}
                                                            value={0}
                                                            {...a11yProps(0)}
                                                        />
                                                    )}
                                                {!isObjectEmpty(data) &&
                                                    data["selectedApprover"]
                                                        .length != 0 && (
                                                        <Tab
                                                            label={
                                                                data.formId !==
                                                                98
                                                                    ? t(
                                                                          `common.portal.approver`
                                                                      )
                                                                    : t(
                                                                          `common.portal.approver98`
                                                                      )
                                                            }
                                                            value={1}
                                                            {...a11yProps(1)}
                                                        />
                                                    )}
                                                {!isObjectEmpty(data) &&
                                                    data[
                                                        "selectedSecondApprover"
                                                    ].length != 0 && (
                                                        <Tab
                                                            label={t(
                                                                `common.portal.secondApprover`
                                                            )}
                                                            value={2}
                                                            {...a11yProps(2)}
                                                        />
                                                    )}
                                                {!isObjectEmpty(data) &&
                                                    data[
                                                        "selectedThirdApprover"
                                                    ].length != 0 && (
                                                        <Tab
                                                            label={t(
                                                                `common.portal.thirdApprover`
                                                            )}
                                                            value={3}
                                                            {...a11yProps(3)}
                                                        />
                                                    )}
                                                {!isObjectEmpty(data) &&
                                                    data[
                                                        "selectedFourthApprover"
                                                    ].length != 0 && (
                                                        <Tab
                                                            label={
                                                                data.formId !==
                                                                98
                                                                    ? t(
                                                                          `common.portal.fourthApprover`
                                                                      )
                                                                    : t(
                                                                          `common.portal.fourthApprover98`
                                                                      )
                                                            }
                                                            value={4}
                                                            {...a11yProps(4)}
                                                        />
                                                    )}
                                            </Tabs>
                                        </Paper>
                                        <TabPanel value={tabOne} index={0}>
                                            {selectedTable("selectedApplicant")}
                                        </TabPanel>
                                        <TabPanel value={tabOne} index={1}>
                                            {selectedTable("selectedApprover")}
                                        </TabPanel>
                                        <TabPanel value={tabOne} index={2}>
                                            {selectedTable(
                                                "selectedSecondApprover"
                                            )}
                                        </TabPanel>
                                        <TabPanel value={tabOne} index={3}>
                                            {selectedTable(
                                                "selectedThirdApprover"
                                            )}
                                        </TabPanel>
                                        <TabPanel value={tabOne} index={4}>
                                            {selectedTable(
                                                "selectedFourthApprover"
                                            )}
                                        </TabPanel>
                                    </Box>
                                    <FormBox>
                                        <Box
                                            display="flex"
                                            justifyContent="flex-end"
                                        >
                                            <Button
                                                variant="contained"
                                                color="primary"
                                                onClick={() =>
                                                    handlePartOneSubmit()
                                                }
                                            >
                                                {t("common.portal.saveBlock")}
                                            </Button>
                                        </Box>
                                    </FormBox>

                                    {/* Part2 */}
                                    {data.formId !== 98 && (
                                        <>
                                            <Box>
                                                <Typography
                                                    variant="h6"
                                                    component="h1"
                                                >
                                                    <br />
                                                    2.&nbsp;
                                                    {t(
                                                        `common.delegation.delegateSpecificForm`
                                                    )}
                                                </Typography>
                                                <Typography
                                                    style={{
                                                        marginBottom: "0.5rem",
                                                    }}
                                                >
                                                    {t(
                                                        "common.delegation.explanationTwo"
                                                    )}
                                                </Typography>
                                                <Typography
                                                    style={{
                                                        whiteSpace: "pre-line",
                                                        marginBottom: "0.5rem",
                                                    }}
                                                >
                                                    {t(
                                                        `common.delegation.instructionThree`
                                                    )
                                                        .split("<br/>")
                                                        .join("\n")}
                                                </Typography>
                                                <Paper>
                                                    <Box
                                                        display="flex"
                                                        justifyContent="space-between"
                                                    >
                                                        <CustomTextField
                                                            label={t(
                                                                `common.delegation.search`
                                                            )}
                                                            required={false}
                                                            inputProps={{
                                                                name: t(
                                                                    `common.delegation.search`
                                                                ),
                                                                autoComplete:
                                                                    "off",
                                                            }}
                                                            placeholder={
                                                                data.formId
                                                                    ? t(
                                                                          `common.delegation.placeHolder`
                                                                      ) +
                                                                      ` (Form${getFormIDwithZero(
                                                                          data.formId
                                                                      )}000001)`
                                                                    : t(
                                                                          `common.delegation.placeHolder`
                                                                      )
                                                            }
                                                            style={{
                                                                width: "100%",
                                                            }}
                                                            value={refNum}
                                                            onChange={(e) =>
                                                                setRefNum(
                                                                    e.target
                                                                        .value
                                                                )
                                                            }
                                                        ></CustomTextField>
                                                        <Button
                                                            style={{
                                                                marginTop:
                                                                    "1rem",
                                                                float: "right",
                                                            }}
                                                            variant="contained"
                                                            color="primary"
                                                            onClick={() =>
                                                                getSpecificFormDetail()
                                                            }
                                                        >
                                                            {t("common.search")}
                                                        </Button>
                                                    </Box>

                                                    {!isObjectEmpty(
                                                        specificList
                                                    ) ? (
                                                        <Box>
                                                            {tempRadio()}
                                                            <React.Fragment>
                                                                <Paper square>
                                                                    <Tabs
                                                                        value={
                                                                            tabTwo
                                                                        }
                                                                        onChange={
                                                                            handleTabTwoChange
                                                                        }
                                                                        aria-label="each level workflow assignee"
                                                                        centered
                                                                    >
                                                                        {!isObjectEmpty(
                                                                            specificList
                                                                        ) &&
                                                                            specificList[
                                                                                "selectedApplicant"
                                                                            ]
                                                                                .length !=
                                                                                0 && (
                                                                                <Tab
                                                                                    label={t(
                                                                                        `common.portal.applicant`
                                                                                    )}
                                                                                    value={
                                                                                        0
                                                                                    }
                                                                                    {...a11yProps(
                                                                                        0
                                                                                    )}
                                                                                />
                                                                            )}
                                                                        {!isObjectEmpty(
                                                                            specificList
                                                                        ) &&
                                                                            specificList[
                                                                                "selectedApprover"
                                                                            ]
                                                                                .length !=
                                                                                0 && (
                                                                                <Tab
                                                                                    label={t(
                                                                                        `common.portal.approver`
                                                                                    )}
                                                                                    value={
                                                                                        1
                                                                                    }
                                                                                    {...a11yProps(
                                                                                        1
                                                                                    )}
                                                                                />
                                                                            )}
                                                                        {!isObjectEmpty(
                                                                            specificList
                                                                        ) &&
                                                                            specificList[
                                                                                "selectedSecondApprover"
                                                                            ]
                                                                                .length !=
                                                                                0 && (
                                                                                <Tab
                                                                                    label={t(
                                                                                        `common.portal.secondApprover`
                                                                                    )}
                                                                                    value={
                                                                                        2
                                                                                    }
                                                                                    {...a11yProps(
                                                                                        2
                                                                                    )}
                                                                                />
                                                                            )}
                                                                        {!isObjectEmpty(
                                                                            specificList
                                                                        ) &&
                                                                            specificList[
                                                                                "selectedThirdApprover"
                                                                            ]
                                                                                .length !=
                                                                                0 && (
                                                                                <Tab
                                                                                    label={t(
                                                                                        `common.portal.thirdApprover`
                                                                                    )}
                                                                                    value={
                                                                                        3
                                                                                    }
                                                                                    {...a11yProps(
                                                                                        3
                                                                                    )}
                                                                                />
                                                                            )}
                                                                        {!isObjectEmpty(
                                                                            specificList
                                                                        ) &&
                                                                            specificList[
                                                                                "selectedFourthApprover"
                                                                            ]
                                                                                .length !=
                                                                                0 && (
                                                                                <Tab
                                                                                    label={t(
                                                                                        `common.portal.fourthApprover`
                                                                                    )}
                                                                                    value={
                                                                                        4
                                                                                    }
                                                                                    {...a11yProps(
                                                                                        4
                                                                                    )}
                                                                                />
                                                                            )}
                                                                    </Tabs>
                                                                </Paper>
                                                                <TabPanel
                                                                    value={
                                                                        tabTwo
                                                                    }
                                                                    index={0}
                                                                >
                                                                    {specificTable(
                                                                        "selectedApplicant"
                                                                    )}
                                                                </TabPanel>
                                                                <TabPanel
                                                                    value={
                                                                        tabTwo
                                                                    }
                                                                    index={1}
                                                                >
                                                                    {specificTable(
                                                                        "selectedApprover"
                                                                    )}
                                                                </TabPanel>
                                                                <TabPanel
                                                                    value={
                                                                        tabTwo
                                                                    }
                                                                    index={2}
                                                                >
                                                                    {specificTable(
                                                                        "selectedSecondApprover"
                                                                    )}
                                                                </TabPanel>
                                                                <TabPanel
                                                                    value={
                                                                        tabTwo
                                                                    }
                                                                    index={3}
                                                                >
                                                                    {specificTable(
                                                                        "selectedThirdApprover"
                                                                    )}
                                                                </TabPanel>
                                                                <TabPanel
                                                                    value={
                                                                        tabTwo
                                                                    }
                                                                    index={4}
                                                                >
                                                                    {specificTable(
                                                                        "selectedFourthApprover"
                                                                    )}
                                                                </TabPanel>
                                                            </React.Fragment>
                                                        </Box>
                                                    ) : (
                                                        <Paper>
                                                            {isInitialSpecific ==
                                                                false && (
                                                                <Typography
                                                                    style={{
                                                                        textAlign:
                                                                            "center",
                                                                        padding:
                                                                            "0.3rem",
                                                                    }}
                                                                >
                                                                    {t(
                                                                        `common.delegation.emptyResult`
                                                                    )}
                                                                </Typography>
                                                            )}
                                                        </Paper>
                                                    )}
                                                </Paper>
                                            </Box>
                                            <FormBox>
                                                <Box
                                                    display="flex"
                                                    justifyContent="flex-end"
                                                >
                                                    <Button
                                                        variant="contained"
                                                        color="primary"
                                                        // type="submit"
                                                        onClick={() =>
                                                            handlePartTwoSubmit()
                                                        }
                                                    >
                                                        {t(
                                                            "common.portal.saveBlock"
                                                        )}
                                                    </Button>
                                                </Box>
                                            </FormBox>
                                        </>
                                    )}
                                    <Typography>
                                        {t(`common.delegation.starExplanation`)}
                                    </Typography>
                                </Box>
                            </form>
                        </main>
                    )
                )}
            </Box>
            <AlertDialog
                formOpen={isSavedOpen}
                content={t("common.portal.changesSaved")}
                confirmButton={{
                    action: () => setIsSavedOpen(false),
                    label: t("common.confirm"),
                }}
            />
        </Container>
    );
}

export default DelegationPage;
